import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuItem } from '../types';
import { HeaderMenuService } from './header-menu.service';

@Component({
  selector: 'crm-header-menu',
  templateUrl: './header-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMenuComponent implements OnInit {
  menuItems$: Observable<MenuItem[]>;

  constructor(private headerMenu: HeaderMenuService) {}

  ngOnInit(): void {
    this.menuItems$ = this.headerMenu.get();
  }
}
